export default __webpack_public_path__ + "static/media/help-rav-inv-1.13d3b509.png";